import React, {Component} from 'react';
import PropTypes from 'prop-types';
import "./style.css"

class Checkbox extends Component {
    handleOnChange(e){

        this.props.onChange(e.target.checked);
    }
    render() {
        return (
            <label className="checkbox-custom-label" >
                <input className="checkbox" onChange={(e)=>{this.handleOnChange(e)}} type="checkbox" name={this.props.name} checked={this.props.value}/>
                <span className="checkbox-custom"></span>
                {
                    this.props.label.length > 0?
                        <span className="label">{this.props.label}</span>
                    :null
                }

            </label>
        );
    }
}

Checkbox.propTypes = {
    label:PropTypes.string,
    value:PropTypes.bool,
    name:PropTypes.string,
    onChange:PropTypes.func.isRequired
};
Checkbox.defaultProps = {
    label:"",
    value:false,
    name:""
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Shared/Checkbox/index.jsx